const { fetcher } = require('services/helpers/responseHandler')

const reEnablePMSSync = subsidiaryId =>
  fetcher.put('internalonly/ReEnablePmsSync', subsidiaryId)

const tryLogin = ({ subsidiaryId, credentialString }) =>
  fetcher.post('internalonly/pms/try-login', {
    subsidiaryId,
    credentialString
  })

const occupancy = ({ fromDate, toDate, subsidiaryId }) =>
  fetcher.get('internalonly/subsidiary/occupancy', {
    fromDate,
    toDate,
    subsidiaryId
  })

const reEnableHostedMessaging = ({ HostMessagingAuthorizingPartyFullName }) =>
  fetcher.post('internalonly/subsidiary/hostnumber', {
    HostMessagingAuthorizingPartyFullName
  })

const getElectronTelemetrySummary = ({ subsidiaryId, startDate, endDate }) =>
  fetcher.post('internalonly/healthcheck/electron-telemetry/summary', {
    subsidiaryId,
    startDate,
    endDate
  })

const getElectronDiagnosticCaptures = ({ subsidiaryId, startDate, endDate }) =>
  fetcher.post('internalonly/healthcheck/electron-telemetry/diagnostic-captures', {
    subsidiaryId,
    startDate,
    endDate
  })

const getPmsHistoriesForHealthCheck = ({ subsidiaryId, month, year }) =>
  fetcher.post('internalonly/healthcheck/pms/histories', {
    subsidiaryId,
    month,
    year
  })

const getPepDailyOperationsReport = ({ reportDateUtc } = {}) =>
  fetcher.post('internalonly/checkups/pep-daily-operations-report', {
    reportDateUtc
  })

const internalOnlyApi = {
  reEnablePMSSync,
  tryLogin,
  occupancy,
  reEnableHostedMessaging,
  getElectronTelemetrySummary,
  getElectronDiagnosticCaptures,
  getPmsHistoriesForHealthCheck,
  getPepDailyOperationsReport
}

export default internalOnlyApi
